// File: src/components/WhyAyushvatika.tsx

import React from "react";
import {
  FaLeaf,
  FaHandHoldingUsd,
  FaFlask,
  FaUserMd,
  FaPaw,
  FaCertificate,
  FaCheckCircle,
} from "react-icons/fa";
import lableimg from "../assets/Ayushvatika product label.png";
import lableimg2 from "../assets/Holistic Support.png";

// --- KEYWORD RICH DATA ---
const benefits = [
  {
    icon: <FaLeaf className="text-3xl md:text-4xl text-[#2e3d2f] group-hover:text-green-600 transition duration-300" />,
    title: "100% Natural Herbs",
    desc: "Premium Grade A Ayurvedic Herbs",
    ariaLabel: "Natural herbal ingredients for ayurvedic medicines"
  },
  {
    icon: <FaUserMd className="text-3xl md:text-4xl text-[#2e3d2f] group-hover:text-green-600 transition duration-300" />,
    title: "Vaidya Formulated",
    desc: "Developed by Expert Ayurvedic Doctors",
    ariaLabel: "Ayurvedic doctor formulated products"
  },
  {
    icon: <FaCertificate className="text-3xl md:text-4xl text-[#2e3d2f] group-hover:text-green-600 transition duration-300" />,
    title: "GMP Certified",
    desc: "Govt Approved Manufacturing",
    ariaLabel: "GMP certified ayurvedic manufacturing"
  },
  {
    icon: <FaPaw className="text-3xl md:text-4xl text-[#2e3d2f] group-hover:text-green-600 transition duration-300" />,
    title: "Cruelty-Free",
    desc: "Ethical & Safe Products",
    ariaLabel: "Cruelty free herbal products"
  },
  {
    icon: <FaFlask className="text-3xl md:text-4xl text-[#2e3d2f] group-hover:text-green-600 transition duration-300" />,
    title: "Toxin Free",
    desc: "No Parabens or Sulphates",
    ariaLabel: "Toxin free and chemical free ayurveda"
  },
  {
    icon: <FaHandHoldingUsd className="text-3xl md:text-4xl text-[#2e3d2f] group-hover:text-green-600 transition duration-300" />,
    title: "COD Available",
    desc: "Secure Cash on Delivery",
    ariaLabel: "Buy ayurvedic medicine cash on delivery"
  },
];

const trustPillars = [
  {
    image: "https://kj1bcdn.b-cdn.net/media/104808/leaves-2.jpg",
    title: "Sourced from Origin",
    desc: "We source potent herbs like Ashwagandha and Shilajit directly from their native origins to ensure you get the best.",
    alt: "Farm fresh ayurvedic herbs sourcing for medicine"
  },
  {
    image: lableimg,
    title: "Transparent Labeling",
    desc: "Authenticity you can trust. Our labels clearly list every ingredient, making us the most transparent ayurvedic brand.",
    alt: "Ayushvatika authentic product label with ingredients"
  },
  {
    image: lableimg2,
    title: "Holistic Support",
    desc: "More than a store. Get guidance from experienced Vaidyas to choose the right ayurvedic remedy for your lifestyle.",
    alt: "Online ayurvedic doctor consultation and support"
  },
];

const WhyAyushvatika: React.FC = () => {
  return (
    <section 
      className="bg-gradient-to-b from-white to-green-50 py-12 px-4" 
      aria-labelledby="why-choose-heading"
    >
      <div className="max-w-6xl mx-auto text-center">
        
        {/* --- Header Section (UNCHANGED) --- */}
        <header className="mb-10">
          <h2 
            id="why-choose-heading" 
            className="text-2xl md:text-3xl font-bold text-[#2e3d2f] mb-3 uppercase tracking-wide"
          >
            Why Choose Ayushvatika for <span className="text-green-700">Authentic Ayurveda?</span>
          </h2>
          <h1 className="sr-only">Best Ayurvedic Products Online Store in India</h1>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto">
            Discover the power of <strong className="font-semibold text-green-800">Real Ayurvedic Formulations</strong>. We bring you scientifically validated, 
            <strong className="font-semibold text-green-800"> 100% natural herbal products</strong> designed for your holistic wellness.
          </p>
        </header>

        {/* --- Feature Grid (UNCHANGED) --- */}
        <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 mb-12 list-none p-0">
          {benefits.map((item, index) => (
            <li
              key={index}
              className="group flex flex-col items-center justify-center bg-white border border-gray-100 rounded-2xl p-4 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
            >
              <div 
                className="mb-2 bg-green-50 p-3 rounded-full group-hover:bg-green-100 transition-colors"
                aria-label={item.ariaLabel}
                role="img"
              >
                {item.icon}
              </div>
              <h3 className="text-xs md:text-sm font-bold text-[#2e3d2f] leading-tight">
                {item.title}
              </h3>
              <span className="text-[10px] text-gray-500 mt-1 hidden sm:block">
                {item.desc}
              </span>
            </li>
          ))}
        </ul>

        {/* --- Trust Badge Strip (UNCHANGED) --- */}
        <div 
          className="py-6 border-y border-gray-200 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-xs md:text-sm text-gray-600 mb-12 bg-white/50 rounded-lg"
          role="note"
        >
          <span className="flex items-center gap-2 font-medium">
            <FaCheckCircle className="text-green-600" aria-hidden="true" /> 100% Authentic Ayurvedic Products
          </span>
          <span className="hidden md:inline text-gray-300" aria-hidden="true">|</span>
          <span className="flex items-center gap-2 font-medium">
            <FaCheckCircle className="text-green-600" aria-hidden="true" /> Secure Online Payment
          </span>
          <span className="hidden md:inline text-gray-300" aria-hidden="true">|</span>
          <span className="flex items-center gap-2 font-medium">
            <FaCheckCircle className="text-green-600" aria-hidden="true" /> Fast Shipping across India
          </span>
        </div>

       
      </div>
    </section>
  );
};

export default WhyAyushvatika;